const DEFAULT_LOCALE = 'enUS';
const LOCALE_MAP = {
  [DEFAULT_LOCALE]: 'English (US)',
  esLA: 'Español',
  esES: 'Español (España)',
  ptBR: 'Português (Brasil)',
  ptPT: 'Português (Portugal)',
  frFR: 'Français (France)',
  deDE: 'Deutsch',
  arME: 'العربية',
  itIT: 'Italiano',
  ruRU: 'Русский',
  hiIN: 'हिंदी',
  idID: 'Bahasa Indonesia',
};

const LOCALE_COOKIE = 'c_locale';

export { DEFAULT_LOCALE, LOCALE_MAP, LOCALE_COOKIE };
